<template>
<section class="pt-8 pt-md-5 pb-8 pb-md-14">
    <div class="container">
        <div class="row">
             <div class="col-12">
                 <div class="alert alert-primary" role="alert">
                     If you're having trouble depositing money, please contact our
                     <a :href="`${$state.siteTgBase}/${$state.siteTgSupport}`">support</a>
                     — we’ll offer you alternative deposit methods.
                 </div>
             </div>
        </div>
        <Spinner v-if="!loaded" />
        <div class="row" v-else>
            <div class="col-12">
                <h1 class="mb-0 fw-bold">Top up your balance</h1>
                <p class="mb-6 text-muted">On this page you can make a payment in a convenient way</p>
                <div class="table-responsive" v-if="ccPaySystems.length > 0">
                    <h3>Web3</h3>
                    <small class="text-secondary">These addresses are tied exclusively to your account, you can deposit with any amount of USDT</small>
                    <table class="table table-striped">
                        <tbody>
                            <tr v-for="system in ccPaySystems" :init="initQR(system)">
                                <td colspan="2">
                                    <label :for="`p${system.id}`" class="text-nowrap">{{ system.description }}</label>
                                    <div class="text-success" v-if="system.client_fee_percent < 0">
                                        We give {{ -system.client_fee_percent }}% when using this payment method (from $200)
                                    </div>
                                    <div class="text-danger" v-else-if="system.client_fee_percent > 0">
                                        Fee {{ system.client_fee_percent }}% when using this payment method
                                    </div>
                                    <hr/>
                                    <pre>
                                        <code>{{ system.address }}</code>
                                    </pre>
                                </td>
                                <td>
                                    <div>
                                        <img :src="system.qr" :alt="`QR for ${system.name}`"/>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="table-responsive" v-if="wwPaySystems.length > 0">
                    <h3>Worldwide</h3>
                    <table class="table table-striped">
                        <tbody>
                            <tr v-for="system in wwPaySystems">
                                <td><input type="radio" v-model="form.system" :value="system" name="paysystem" :id="`p${system.id}`"></td>
                                <td>
                                    <label :for="`p${system.id}`" class="text-nowrap">{{ system.description }}</label>
                                    <div class="text-success" v-if="system.client_fee_percent < 0">
                                        We give {{ -system.client_fee_percent }}% when using this payment method
                                    </div>
                                    <div class="text-danger" v-else-if="system.client_fee_percent > 0">
                                        Fee {{ system.client_fee_percent }}% when using this payment method
                                    </div>
                                </td>
                                <td><label :for="`p${system.id}`">{{ system.currency__code }}</label></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="table-responsive" v-if="ruPaySystems.length > 0">
                    <h3>Russian Federation</h3>
                    <table class="table table-striped">
                        <tbody>
                            <tr v-for="system in ruPaySystems">
                                <td><input type="radio" v-model="form.system" :value="system" name="paysystem" :id="`p${system.id}`"></td>
                                <td>
                                    <label :for="`p${system.id}`" class="text-nowrap">{{ system.description }}</label>
                                    <div class="text-success" v-if="system.client_fee_percent < 0">
                                        We give {{ -system.client_fee_percent }}% when using this payment method
                                    </div>
                                    <div class="text-danger" v-else-if="system.client_fee_percent > 0">
                                        Fee {{ system.client_fee_percent }}% when using this payment method
                                    </div>
                                </td>
                                <td><label :for="`p${system.id}`">{{ system.currency__code }}</label></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <form class="mb-6" @submit.prevent="pay" v-show="form.system.id">
                    <div class="form-group">
                        <label class="form-label" for="amount">Amount</label>
                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon1">{{ form.system.currency__symbol }}</span>
                            <input type="number" :min="minAmount" class="form-control" id="amount" v-model="form.amount"
                                   placeholder="Enter the amount" aria-describedby="basic-addon1" /><br>
                            <div clear="both" />
                        </div>
                        <small class="form-text text-danger" v-for="error in errors.amount">{{ error }}</small>
                    </div>
                    <button class="btn w-100 btn-primary" type="submit" :disabled="disabled">
                        Pay
                    </button>
                </form>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import Spinner from "../Spinner"
import QRCode from "qrcode"
import { processPayment } from "utils/payment";

export default {
    components: {
        Spinner
    },
    data() {
        return {
            loaded: false,
            disabled: false,
            paySystems: [],
            ccPaySystems: [],
            wwPaySystems: [],
            ruPaySystems: [],
            minAmount: 1,
            errors: {},
            form: {amount: 100, system: {}},
        }
    },
    methods: {
        pay() {
            this.errors = {}
            this.disabled = true
            let amount = this.form.amount,
                system = this.form.system.id
            this.$services.Payment().save({amount, system}).then(resp => {
                processPayment(
                    this,
                    resp,
                    null,
                    (errors) => { this.errors = errors }
                );
            }).finally(() => {
                this.disabled = false
            })
        },
        fetch(data) {
            data = data || {}
            this.loaded = true // hack
            this.$services.PaymentSystem().get(data).then(resp => {
                this.paySystems = resp.body.data;
                this.ccPaySystems = this.paySystems.filter(s => s.group == 'cc')
                this.wwPaySystems = this.paySystems.filter(s => s.group == 'ww')
                this.ruPaySystems = this.paySystems.filter(s => s.group == 'ru')
            }).finally(() => {
                this.loaded = true
            })
        },
        initQR(system) {
            QRCode.toDataURL(system.address).then(qr => {
                system.qr = qr
            })
        }
    },
    created() {
        this.fetch()
    },
    watch: {
        'form.system'(val, old) {
            if (val) {
                this.minAmount = this.form.amount = val.currency__min_amount
            } else {
                this.minAmount = this.form.amount = 50
            }
        }
    }
}
</script>
